export default __webpack_public_path__ + "static/media/cryptonite.f99e7941.png";